var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table-layout"},[_c('div',{staticClass:"table-search-form"},[_c('div',{staticClass:"form-wrap"},[_vm._t("search-form")],2)]),_vm._v(" "),_c('div',{staticClass:"table-content"},[_c('div',{staticClass:"table-wrap"},[_vm._t("table-wrap")],2)]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7545a393","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/TableLayout.vue
// module id = null
// module chunks = 